//  -----   FUNZIONAMENTO   -----
/** 
analogo a sidebar_resize_mixin
*/
import {
  eventBus
} from '../eventbus'

export default {
  mounted: function () {
    this.$nextTick(function () {
      this.grab_sup_wtree = !this.right ? '.wtree_right' : '.wtree_left';
      this.grab_sup_wfake = !this.right ? '.wtree_fake_right' : '.wtree_fake_left';
    })
  },
  data: function () {
    return {
      start_sup_w: 0,
      grab_sup_wtree: '',
      grab_sup_wfake: '',
      supportDefaults: {
        Impieghi: 320,
        Anteprime: 270,
        Documenti: 270,
        Stampa: 270
      }
    }
  },
  methods: {
    attachSupportListeners: function () {
      var vm = this;
      var starting_els = $('.sup-resize-start');
      var stopping_els = $('.sup-resize-stop');

      starting_els.bind("mousedown.start", function (e) { //DESKTOP
        //LEFT: Coordinata X di partenza = larghezza sidebar
        //RIGHT: Coordinata X di partenza = largezza finestra - larghezza sidebar
        var width = $(vm.grab_sup_wtree).width();
        if (!vm.right) {
          width = window.innerWidth - width; // 50 margine
        }
        vm.start_sup_resize(width);
      });

      starting_els.bind("touchstart.start", function (e) { //PORTABLE
        vm.start_sup_resize(e.originalEvent.changedTouches[0].screenX);
      });

    },
    reset_sup_resize: function () {
      this.start_sup_w = 0;
      //rimuovo i listeners mousemove e mouseup a sidebar e container
      this.removeStopListeners();
      //resetto larghezza placeholder e lo setto in background, + resetto profondità toolbar
      $(this.grab_sup_wfake).css("z-index", -1);
      $(this.grab_toolbar).css("z-index", 810);
      $(this.grab_sup_wfake).width($(this.grab_sup_wtree).width())
    },
    start_sup_resize: function (x) {
      var vm = this;
      this.start_sup_w = x;
      var stopping_els = $('.sup-resize-stop');
      var resetting_els = $('.resize-reset');

      stopping_els.bind("mousemove.track", function (e) { //DESKTOP
        //setto placeholder in primo piano, così da vedere l'effetto di trasparenza 
        //il placeholder non deve sovrapporsi con la toolbar
        $(vm.grab_sup_wfake).css("z-index", 813);
        $(vm.grab_toolbar).css("z-index", 9999);
        var w = $(vm.grab_sup_wfake).width();
        if (!vm.right) {
          w = window.innerWidth - w // 50 margin
        }
        //apply con fake = true, e larghezza placehodler come X di partenza (LEFT), largezza finestra - larghezza sidebar (RIGHT)
        vm.sup_apply(e.clientX, true, w);
      });

      stopping_els.bind("touchmove.track", function (e) { //PORTABLE
        //setto placeholder in primo piano, così da vedere l'effetto di trasparenza 
        $(vm.grab_sup_wfake).css("z-index", 813);
        $(vm.grab_toolbar).css("z-index", 9999);
        var w = $(vm.grab_sup_wfake).width();
        if (!vm.right) {
          w = window.innerWidth - w
        }
        //apply con fake = true, e larghezza placehodler come X di partenza (LEFT), largezza finestra - larghezza sidebar (RIGHT)
        vm.sup_apply(e.originalEvent.changedTouches[0].clientX, true, w);
      });

      stopping_els.bind("mouseup.end", function (e) { //DESKTOP
        vm.stop_sup_resize(e.clientX);
      });

      stopping_els.bind("touchend.end", function (e) { //PORTABLE
        vm.stop_sup_resize(e.originalEvent.changedTouches[0].screenX);
      });

      resetting_els.bind("mouseup.end", function () { //DESKTOP
        vm.reset_sup_resize();
      });

      resetting_els.bind("touchend.end", function () { //PORTABLE
        vm.reset_sup_resize();
      });

    },
    stop_sup_resize: function (x) {
      //rimuovo i listeners mousemove e mouseup a sidebar e container
      this.removeStopListeners();
      //setto placeholder in background
      $(this.grab_sup_wfake).css("z-index", -1);
      $(this.grab_toolbar).css("z-index", 810);

      if (this.start_sup_w != 0) {
        this.sup_apply(x, false);
      } else {
        this.start_sup_w = 0;
      }
    },
    sup_apply: function (end_w, fake, fake_start, straight) {
      var grab_w,
        grab_m,
        tableModal = '.tableModal',
        start;

      //grab_w contiene il selector a wtree o wtree_fake a seconda di cosa si sta calcolando
      if (!fake) {
        start = this.start_sup_w;
        grab_w = this.grab_sup_wtree;
        grab_m = this.right ? '.mtree_right' : '.mtree_left';
      } else {
        start = fake_start;
        grab_w = this.grab_sup_wfake
      }
      var difference, width, new_size;
      if (straight == null) {
        difference = !this.right ? start - end_w : end_w - start;
        width = $(grab_w).width();
        new_size = (width + difference);
        if (!fake) {
          eventBus.$emit("newSupportSide", new_size);
        }

      } else {
        new_size = straight;
      }

      var contentWrapperWidth = (window.innerWidth - new_size);
      //Minimo: 270px, Massimo: Metà Larghezza Finestra
      new_size = Math.min((Math.max(270, new_size)), window.innerWidth / 2);
      var new_marg = (new_size) + 'px';
      if (fake) {
        new_size = new_size + 'px';
      } else {
        new_size = (new_size - 50) + 'px';
      }

      $(grab_w).width(new_size);
      var modalMargin = ((contentWrapperWidth - 640) / 2);
      //non modifico i margini se sto calcolando solo la larghezza del placeholder 
      if (!fake) {
        if (!this.right) {
          $(grab_m).css("margin-right", new_marg);
        } else {
          $(grab_m).css("margin-left", new_marg);
          $(tableModal).css("margin-left", modalMargin + 'px');
          $(tableModal).css("margin-right", modalMargin + 'px');
        }
      }
      if (!fake) {
        //non resetto il "reale" punto di partenza se sto calcolando solo la larghezza del placeholder 
        this.start_sup_w = 0;
      }
    },
    removeSupportSidebarListeners: function () {
      this.removeStartListeners();
      this.removeStopListeners();
    },
    removeStartListeners: function () {
      var starting_els = $('.sup-resize-start');
      starting_els.unbind('mousedown.start');
      starting_els.unbind('touchstart.start');
    },
    removeStopListeners: function () {
      var stopping_els = $('.sup-resize-stop');
      stopping_els.unbind('mousemove.track');
      stopping_els.unbind('touchmove.track');
      stopping_els.unbind('mouseup.end');
      stopping_els.unbind('touchend.end');

      var resetting_els = $('.resize-reset');
      resetting_els.unbind('mouseup.end');
      resetting_els.unbind('touchend.end');
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/support_sidebar_resize_mixin.js